import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Card, Button, Modal, Row, Col, Form } from 'react-bootstrap'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { useNavigate } from 'react-router-dom'
import {obtenerComboRegistrarHito} from '../../../store/actions/cierre-gestion-action'
import {serviceCerrarCaso} from '../../../api/api-cierre-gestion';
import Mensajes from '../../mensajes'

const CerrarCaso = ({showCerrarCaso, handleCloseCerrarCaso}) => {

    const dispatch = useDispatch()
    const [loading, setLoading]=useState(false)  

    const { rutUsuario, rutOrganizacion } = Auth.currentUser()

    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
    const {llaves} = data_recepciona

    const data_gestion = useSelector((state) => state.procesoExtrajudicialReducer)
    const {datosGestionImplicado} = data_gestion

    const data_cierre_modal = useSelector((state) => state.cierreGestionReducer)
    const {comboRegistrarHito} = data_cierre_modal

    const [tipoGestion, setTipoGestion] = React.useState(false)
    const [ambitoGestion, setAmbitoGestion] = React.useState(false)

    const [registrarHito, setRegistrarHito] = React.useState('')
    const [comentario, setComentario] = useState('')

    const [showToast, setShowToast] = useState(false);
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true) 

    const [responseData, setResponseData] = useState({})

    const history = useNavigate()

    useEffect(() => {
      setTipoGestion(datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'] !== '' && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'] !== null && datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion'] !== undefined ? parseInt(datosGestionImplicado.datosGestionImplicado[0]['codTipoGestion']) : '')
      setAmbitoGestion(datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'] !== '' && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'] !== null && datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion'] !== undefined ? parseInt(datosGestionImplicado.datosGestionImplicado[0]['codAmbitoGestion']) : '')
    }, [datosGestionImplicado])
  
    useEffect(() => {
      setLoading(true)
      let query = Buffer.from(JSON.stringify({tipoGestion: tipoGestion, ambitoGestion: ambitoGestion, idSituacion: 215003, idModoIngreso: null})).toString('base64')
      dispatch(obtenerComboRegistrarHito(query)).then(()=>setLoading(false))
    }, [])

    useEffect(() => {
      setRegistrarHito('');
      setComentario('');      
    }, [showCerrarCaso])

    const handleCerrar = async () => {
      
      setLoading(true);

      let dataForm = {};

      dataForm.idCaso = llaves && llaves["idCaso"];
      dataForm.idImplicadoCaso = llaves && llaves["idImplicado"];
      dataForm.idOrganizacion = llaves && llaves["idOrgCaso"];
      dataForm.idUsuario = rutUsuario;
      dataForm.cierreConRecupero = 0;//Cierre sin Recupero
      dataForm.codHito = registrarHito;
      dataForm.fechaHito = new Date();
      dataForm.minutaHito = comentario;

      console.log("dataForm", dataForm);

      const response = await serviceCerrarCaso(dataForm);
      setLoading(false);
      setResponseData(response);
      setShowToast(true);
    }

    const queryState = JSON.parse(localStorage.getItem('filtrosRecuperoDirecto'))
    useEffect(()=>{
      console.log("responseData: ", responseData);
      if(responseData && responseData["code"]===1){
        setTimeout(()=> history('/area-trabajo-recupero-directo',{state:{queryState}}),2000)      
      }
    },[responseData])

    return (
    <div>
      <LoadingComponent show={loading}/>
      <Modal size="xl" show={showCerrarCaso} onHide={handleCloseCerrarCaso}>
        <Card>
          <Card.Header className='mt-0 mb-0' as='h6' style={{backgroundColor: '#4F517A', color: 'white'}}>
              {'Cierre del Caso'}
          </Card.Header>
        </Card>
        <Modal.Body>

          <Row>
            <Col md="4">
              <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                {"Situación de Término "+"*"} 
              </Form.Label>
              {' '}
              <br/>
              <Form.Select  aria-label='Default select example'
                onChange={
                    (e) => {
                        setRegistrarHito(e.target.value)                        
                    }
                }
                name='codHito'
                value={(registrarHito)}
                >
                <option value={''}>Seleccione...</option>
                {
                comboRegistrarHito && comboRegistrarHito.comboRegistrarHito ?. map((c) => (
                    <option key={c.id} value={c.id}>
                        {c.nombre}
                    </option>
                ))
              } </Form.Select>
            </Col>
            <Col md="6">
                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold',fontSize: '14px'}}>
                    {'Comentario'}
                </Form.Label>
                {' '}
                <br/>
                <Form.Control as='textarea' className='mb-2'
                    rows={2}
                    onChange={
                        (e) => {
                            setComentario(e.target.value)
                        }
                    }
                    name='minutaHito'
                    value={(comentario)}
                  />                    
            </Col>
          </Row>
          <Row>
            <Col>
                {responseData && 
                    <Mensajes
                        showToast={showToast}
                        handleCloseToast={handleCloseToast}
                        delay={5000}
                        responseData={responseData}
                    ></Mensajes>
                }
            </Col>
          </Row>

        </Modal.Body>        
        <Modal.Footer>
          <Button variant='outline-info' onClick={handleCloseCerrarCaso}>Cerrar</Button>
          <Button variant='primary' onClick={handleCerrar}>Confirmar Cierre</Button>
        </Modal.Footer>        
      </Modal>
    </div>
  )
}
export default CerrarCaso
